import * as CONSTANTS from "../../utils/constants/constants";

export function GetSocketName (socketname: string) {

    // User incsecure websockets for 127.0.0.1. Secure websockets for everything else
    return CONSTANTS.WS_HOST() + "ws/" + socketname + "/";

  }
  